function moduleLightbox() {

	let rootElement = document.querySelector('.page-container');
	if (!rootElement) return;

	let triggerClass = 'module-lightbox-trigger';

	rootElement.addEventListener('click', function (e) {

		let mlTrigger = event.target;
		if (!mlTrigger.classList.contains(triggerClass)) return;

		e.preventDefault();

		let item = mlTrigger.closest('.module-lightbox-wrapper');
		if (!item) return;

		let isActive = item.classList.contains('active');
		if (document.querySelector('.module-lightbox-wrapper.active')) {
			document.querySelector('.module-lightbox-wrapper.active').classList.remove('active');
		}
		if (!isActive) {
			item.classList.add('active');
		}
		document.body.classList.add('module-lightbox-is-toggled');

		let slickTrackWithVideo = item.closest('.slick-track');
		let slickListWithVideo = '';
		let slickTrackTransformStyleValues = '';

		if ( slickTrackWithVideo ) {
			slickListWithVideo = slickTrackWithVideo.closest('.slick-list');
			if ( slickListWithVideo ) {
				let slickTrackTransformStyle = window.getComputedStyle(slickTrackWithVideo);
				slickTrackTransformStyleValues = slickTrackTransformStyle.transform || slickTrackTransformStyle.webkitTransform || slickTrackTransformStyle.mozTransform;
				slickTrackWithVideo.style.transform = 'none';	
				slickListWithVideo.style.transform = 'none';	
			}
		}

		// let slickSliderTransform 
		let iframes    = item.getElementsByTagName('iframe')[0];	
		let iframeUpdate = function() {
			let iframeSrc  = iframes.src;
			iframes.src = '';
			iframes.src = iframeSrc;
		}

		let mlClose = item.querySelector('.module-lightbox-close');
		if (mlClose) {
			mlClose.addEventListener('click', function () {
				if ( slickTrackWithVideo && slickListWithVideo ) {
					slickTrackWithVideo.style.transform = slickTrackTransformStyleValues;
				}
				item.classList.remove('active');
				document.body.classList.remove('module-lightbox-is-toggled');
				if(iframes) {
					iframeUpdate();
				}
			});
		}

		let mlBlock = item.querySelector('.module-lightbox-block');
		let mlContainer = item.querySelector('.module-lightbox-container');
		if (mlBlock && mlContainer) {
			mlContainer.addEventListener('click', function(e) {
				if ( !mlBlock.contains(e.target) ) {
					if ( slickTrackWithVideo && slickListWithVideo ) {
						slickTrackWithVideo.style.transform = slickTrackTransformStyleValues;
					}
					item.classList.remove('active');
					document.body.classList.remove('module-lightbox-is-toggled');
					if(iframes) {
						iframeUpdate();
					}
				}
			});
		}
		
		window.addEventListener('resize', () => {
			if ( !mlBlock.contains(e.target) ) {
				if ( slickTrackWithVideo && slickListWithVideo ) {
					slickTrackWithVideo.style.transform = slickTrackTransformStyleValues;
				}
				item.classList.remove('active');
				document.body.classList.remove('module-lightbox-is-toggled');
				if(iframes) {
					iframeUpdate();
				}
			}
		});
	});
}

export default moduleLightbox;